import { PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap";
import { useState } from "react";

const TooltipPopover = (props: any) => {
    const [open, setOpen] = useState(false);
    const [id, setId] = useState("id" + Math.random().toString(16).slice(2));

    return (
        <>
            {false && <><i className="fa fa-light fa-square-question text-primary ms-1 fs-16" id={id} onClick={() => setOpen(true)}></i>
            <UncontrolledPopover placement="top" isOpen={open} target={id} toggle={() => setOpen(false)}>
                <PopoverHeader>
                    <div className='d-flex justify-content-between mb-0 pb-0'>
                        <div>{props.title}Help</div>
                        <i className="fa fa-light fa-xmark align-bottom" onClick={() => setOpen(false)}></i>
                    </div>
                </PopoverHeader>
                <PopoverBody>{props.description}Some information about this field</PopoverBody>
            </UncontrolledPopover></>}
        </>
    )
}

export default TooltipPopover;
